export const inputClass =
  'w-full rounded-full border-2 border-[#424245] bg-[#1c1c1e] px-5 py-[18px] text-[17px] text-[#f5f5f7] placeholder-[#6e6e73] outline-none transition-colors focus:border-accent';

// Labels stay in the DOM for screen readers; the visible label is the placeholder (marketing design).
export const labelClass = 'sr-only';
